export default __webpack_public_path__ + "static/media/Logo_ChannelConnect APAC.258e5e32.png";